import React from 'react'
import { tokens } from '@arvoreeducacao/bonsai-ds'
import { useTranslation } from 'i18n'
import useUserPlatform from 'utils/hooks/use-platform'
import {
  Icon,
  Li,
  Container,
  Subtitle,
  Text,
  Button,
  Wrapper
} from '../select-entity-item/SelectEntityItem.style'
import { PROFILE_SWITCH_PATH, useProfileSwitch } from './useProfileSwitch'

type SelectProfileItemProps = {
  entityName?: string
}

const SelectProfileItem: React.FC<SelectProfileItemProps> = ({
  entityName
}) => {
  const { t } = useTranslation()
  const { isSmallerThanTablet } = useUserPlatform()
  const { shouldRenderProfileSwitch, firstName } = useProfileSwitch()

  if (!shouldRenderProfileSwitch) return null

  return (
    <Li
      data-testid="select-profile-item"
      onClick={() => (window.location.href = PROFILE_SWITCH_PATH)}
    >
      <Wrapper>
        <Icon
          iconName="user"
          color={tokens.colors.dark5}
          size={16}
          sizeMobile={16}
        />
        <Container>
          <Subtitle color={tokens.colors.dark4}>{t('Você está em:')}</Subtitle>
          <Text color={tokens.colors.dark5}>
            {`${t('Perfil de')} ${firstName}`}
          </Text>
          {entityName && (
            <Subtitle color={tokens.colors.dark4}>{entityName}</Subtitle>
          )}
        </Container>
      </Wrapper>
      <Button
        theme={{
          type: 'secondary',
          size: isSmallerThanTablet ? 'small' : 'medium'
        }}
        text={
          entityName ? t('Trocar de perfil ou escola') : t('Trocar de perfil')
        }
        fluid
        iconName="users"
        isLeft
      />
    </Li>
  )
}

export default SelectProfileItem
